import { ResourceCard } from "./ResourceCard";
import { affiliateProducts } from "@/utils/affiliateProducts";

export const ResourcesGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16 max-w-7xl mx-auto">
      {affiliateProducts.map((resource, index) => (
        <ResourceCard
          key={resource.title}
          {...resource}
          index={index}
        />
      ))}
    </div>
  );
};